<div class="text-current block relative min-w-[40px] min-h-[40px]">
  <div *ngIf="showSpinner">
    <div class="absolute top-[calc(50%-12px)] left-[calc(50%-12px)]">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  </div>

  <app-popover #bookmarkPopover placement="right" [closeOnOutsideClick]="true" (closeDialog)="processAfterDialogClose()">
    <!-- OFF -->
    <button
      *ngIf="!isBookmarked && !showSpinner"
      class="leading-[1] text-text-sub disabled:opacity-50 disabled:cursor-not-allowed"
      mat-icon-button
      [disabled]="disabled"
      [matTooltip]="!disabled ? 'お気に入り登録' : null"
      matTooltipPosition="above"
      (click)="handleOffClick()"
      popoverTrigger
    >
      <mat-icon class="icon" aria-hidden="false" aria-label="お気に入り登録">star_border</mat-icon>
    </button>

    <!-- ON -->
    <button
      *ngIf="isBookmarked && !showSpinner"
      class="leading-[1] text-primary disabled:opacity-50 disabled:cursor-not-allowed"
      mat-icon-button
      [disabled]="disabled"
      [matTooltip]="!disabled ? 'お気に入りを変更' : null"
      matTooltipPosition="above"
      (click)="handleOnClick()"
      popoverTrigger
    >
      <mat-icon class="icon" aria-hidden="false" aria-label="お気に入りを変更">star</mat-icon>
    </button>

    <div popoverContent class="-m-4 p-0">
      <div class="text-[14px] font-bold mt-0 text-text flex items-center p-3 border-b border-border-line max-w-full">
        <mat-icon class="text-primary" aria-hidden="false" aria-label="">star</mat-icon>
        お気に入りに登録
        <div class="ml-auto">
          <button
            mat-icon-button
            class="close opacity-50 hover:opacity-100 min-w-[20px] w-[20px] h-[20px] leading-[1] !px-0"
            (click)="bookmarkPopover.close()"
          >
            <mat-icon class="text-[12px] size-[12px] leading-[1]">close</mat-icon>
          </button>
        </div>
      </div>
      <div class="overflow-y-auto max-h-[min(60vh,260px)]">
        <div class="p-3 px-4 flex flex-col gap-3 min-h-[100px]">
          <div *ngFor="let list of bookmarkProblemLists; let last = last" class="text-[0.825rem] last:border-b-0">
            <mat-checkbox
              color="primary"
              [checked]="list.checked"
              (change)="onListChange(list.listId, $event.checked, list.isProblemCountMaxExceeded)"
              class="[&_.mat-checkbox-label]:whitespace-normal [&_.mat-checkbox-label]:leading-[1.3]"
              [disabled]="list.isProblemCountMaxExceeded && !list.checked"
            >
              {{ list.name }}
            </mat-checkbox>
          </div>
        </div>
      </div>
      <!-- 上限未到達時：現在の入力UIを表示 -->
      <div *ngIf="!isLimitExceeded" class="flex items-center gap-2 justify-between mt-2 p-2 border-t border-border-line">
        <i class="text-sub material-symbols-outlined">list_alt_add</i>
        <input
          #newListName
          type="text"
          class="flex-grow rounded border border-border-line px-2 py-1 text-sm min-w-0"
          placeholder="新しいリストを作成して追加"
          [(ngModel)]="listName"
        />
        <button
          mat-flat-button
          color="primary"
          class="text-sm h-[28px] w-[40px] min-w-[40px] leading-[1] p-0"
          (click)="createBookmarkProblemList()"
          [disabled]="!listName || listName.length > BOOKMARK_PROBLEM_LIST_NAME_MAX_COUNT"
        >
          追加
        </button>
      </div>

      <!-- 上限到達時：メッセージと管理画面への誘導を表示 -->
      <div *ngIf="isLimitExceeded" class="flex items-center gap-2 justify-between mt-2 p-2 border-t border-border-line">
        <i class="text-sub material-symbols-outlined">list_alt_add</i>
        <span class="text-sm text-sub flex-grow">リスト作成は50個までです</span>
        <button
          mat-flat-button
          class="text-sm h-[28px] leading-[1] bg-gray-30 hover:bg-gray-50 min-w-0 px-2"
          (click)="navigateToBookmarkManagement()"
        >
          管理へ
        </button>
      </div>
    </div>
    <div class="override-popover"></div>
  </app-popover>
</div>
